// extracted by mini-css-extract-plugin
export default {"root":"Error-root_uRLCv"};